import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router";
import { CardPageLayout } from "component-lib/CardPageLayout";
import {
  propertyDetailGetProperty,
  propertyDetailGetDealMetrics,
  propertyDetailGetNewPropertyOwner,
  propertyDetailGetNewProperty,
  getPropertiesAndProjectionsOfDealByPropertyId,
  deleteProperty
} from "./propertyDetail.store";
import { mapCompanySelector, mapGuestPermissions } from "store/state/auth";
import { PrimaryButton, ButtonSizeOptions, SecondaryButton, DEAL_METRICS, GUEST_PERMISSIONS } from "@loanbossinc/component-library";
import { PropertyGeneralInformation } from "./property-general-information/property-general-information";
import { PropertyHistory } from "./property-history/property-history";
import PropertyRentRolls from "./property-rent-rolls/property-rent-rolls";
import { PropertyOwnership } from "./property-ownership/property-ownership";
import { PropertyDisposition } from "./property-disposition/property-disposition";
import { ProjectionsVariables } from "./projections-variables/projections-variables";
import { PropertyHeroCard } from "component-lib/PropertyHeroCard";
import { PropertySummary } from "./property-summary/property-summary";
import moment from "moment";
import guestPermissionHelper from "utils/guestPermissionHelper";
import { SimpleInfoModal } from "modals/SimpleInfoModal";
import UploadRentRollModal from "modals/RentRolls/UploadRentRollModal";
import _ from "lodash";
import { getAccountingIntegrationsForModel } from "../../store/state/accountingIntegration";

const dealMetrics = [DEAL_METRICS.CLOSING_DATE, DEAL_METRICS.PURCHASE_PRICE, DEAL_METRICS.SQUARE_FEET];

const StyledBodyWrapper = styled.div`
  && {
    display: flex;
    flex-direction: column;
  }
`;

const StyledTitleSection = styled.div`
  && {
    display: flex;
    flex-direction: row;

    .title {
      font-family: Work Sans;
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
      display: flex;
      align-items: center;
      text-align: center;

      color: #000000;
    }
  }
`;

const SIMPLE_INFO_MODAL = "SIMPLE_INFO_MODAL";
const UPLOAD_RENT_ROLL_MODAL = "UPLOAD_RENT_ROLL_MODAL";

class PropertyDetail extends Component {
  state = {
    isAllExpanded: false,
    isAllCollapsed: false,
    openModal: { name: null, data: null },
    heroCardButtons: [],
    confirmationModal: {
      title: "",
      onClose: () => {},
      onAccept: () => {},
      content: ""
    }
  };

  componentDidMount() {
    const { propertyId, dealId } = this.props.match.params;
    if (propertyId === "new") {
      this.props.propertyDetailGetNewProperty({ propertyId, dealId });
    } else {
      this.props.propertyDetailGetProperty({ propertyId });
      this.props.propertyDetailGetDealMetrics({ propertyId, dealMetrics });
      this.props.getPropertiesAndProjectionsOfDealByPropertyId({ propertyId });
      this.props.getAccountingIntegrationsForModel("property", propertyId);
    }
  }

  componentDidUpdate(prevProps) {
    const { propertyId } = this.props.match.params;
    const { propertyData } = this.props;
    if (propertyId === "new" && propertyData && propertyData.property && propertyData.property.id) {
      const newPropertyId = propertyData.property.id;
      this.props.history.replace(`/properties/${newPropertyId}`);
      this.props.propertyDetailGetProperty({ newPropertyId });
      this.props.propertyDetailGetDealMetrics({ newPropertyId, dealMetrics });
      this.props.getPropertiesAndProjectionsOfDealByPropertyId({ newPropertyId });
    }

    if (this.props !== prevProps) {
      this.setHeroCardButtons();
    }
  }

  openModal = (name, data = null) => this.setState({ openModal: { name, data } });
  closeModal = () => this.setState({ openModal: { name: null, data: null } });
  isModalOpen = modalName => {
    const { openModal } = this.state;
    return openModal.name === modalName;
  };

  setHeroCardButtons = () => {
    const deleteButton = this.deleteButton();
    if (deleteButton) this.setState({ heroCardButtons: [deleteButton] });
  };

  deleteButton = () => {
    const { authentication } = this.props;
    const { propertyId, dealId } = this.props.match.params;
    if (!authentication || authentication.isGuest || !authentication.isSystemAdmin) return null;

    return {
      label: "Delete Property",
      onClick: () => {
        this.openConfirmationDialog(
          "Delete Property",
          this.closeModal,
          () => {
            if (propertyId) this.props.deleteProperty({ propertyId: propertyId, dealId, callback: () => this.props.history.goBack() });
            this.closeModal();
          },
          <>
            <p>Are you sure that you want to delete this property?</p> <p>This action cannot be undone.</p>
          </>
        );
      }
    };
  };

  openConfirmationDialog = (title, onClose, onAccept, content) => {
    this.setState({ confirmationModal: { title, onClose, onAccept, content } });
    this.openModal(SIMPLE_INFO_MODAL);
  };
  openRentRollDialog = (title, onClose) => {
    this.setState({ confirmationModal: { title, onClose } });
    this.openModal(UPLOAD_RENT_ROLL_MODAL);
  };

  isPropertySold = () => {
    const { propertyData } = this.props;
    const actualExitDate = propertyData?.property?.actualExitDate;
    const momentDate = moment(actualExitDate);
    if (!propertyData.property || !actualExitDate || !momentDate.isValid()) return false;
    return momentDate.isBefore();
  };

  renderTitle = () => (
    <StyledTitleSection>
      <div className="title">Property Details</div>
      <SecondaryButton
        style={{ marginLeft: "auto" }}
        label="Collapse All"
        onClick={() => this.setState({ isAllCollapsed: true })}
        size={ButtonSizeOptions.smFluid}
      />
      <PrimaryButton style={{ marginLeft: 24 }} label="Expand All" onClick={() => this.setState({ isAllExpanded: true })} size={ButtonSizeOptions.smFluid} />
    </StyledTitleSection>
  );

  renderBody = () => {
    const { propertyData, history, propertyProjections, authentication, guestPermission } = this.props;
    const { propertyId } = this.props.match.params;
    const { isAllExpanded, isAllCollapsed } = this.state;
    const isSold = this.isPropertySold();

    const groupProps = {
      data: { ...propertyData.property, accountingIntegrations: this.props.accountingIntegrations },
      propertyProjections: propertyProjections,
      history,
      propertyId,
      shouldExpandAll: isAllExpanded,
      onToggleExpandAll: () => this.setState({ isAllExpanded: false }),
      shouldCollapseAll: isAllCollapsed,
      onToggleCollapseAll: () => this.setState({ isAllCollapsed: false }),
      enableEditButton: guestPermissionHelper.enableEditButton(authentication, guestPermission, GUEST_PERMISSIONS.EDIT),
      enableEditOwnershipCompanyButton: (authentication && authentication.isSystemAdmin)
    };

    const showProjectionsVariables = !authentication.isGuest || (authentication.isGuest && guestPermission && !!guestPermission.portfolioProjections);
    if (!isSold) {
      return (
        <>
          <PropertySummary property={propertyData.property} />
          <PropertyGeneralInformation {...groupProps} />
          {groupProps.data && (
            <PropertyRentRolls
            {..._.omit(groupProps, ["data", "propertyProjections"])}
            companyId={this.props.company?.id}
            openModal={this.openRentRollDialog}
            closeModal={this.closeModal}
            />
          )}
          <PropertyHistory {...groupProps} />
          <PropertyOwnership {...groupProps} newItem={this.props.propertyDetailGetNewPropertyOwner} />
          <PropertyDisposition {...{ isSold, ...groupProps }} />
          {showProjectionsVariables && <ProjectionsVariables {...{ ...groupProps }} />}
        </>
      );
    }

    return (
      <>
        <PropertyDisposition {...{ isSold, ...groupProps }} />
        <PropertySummary property={propertyData.property} />
        <PropertyGeneralInformation {...groupProps} />
        {groupProps.data && (
          <PropertyRentRolls {..._.omit(groupProps, ["data", "propertyProjections"])} openModal={this.openRentRollDialog} closeModal={this.closeModal} />
        )}
        <PropertyHistory {...groupProps} />
        <PropertyOwnership {...groupProps} newItem={this.props.propertyDetailGetNewPropertyOwner} />
        {showProjectionsVariables && <ProjectionsVariables {...{ ...groupProps }} />}
      </>
    );
  };

  onBackButtonClick = () => {
    this.props.history.push(`/deal/${this.props.propertyData.property.dealId}`);
  };

  render() {
    if (!this.props.propertyData) return null;

    return (
      <>
        <CardPageLayout
          {...this.props}
          isReversed
          bannerImageUrl={
            this.props.propertyData &&
            this.props.propertyData.property &&
            this.props.propertyData.property.deal &&
            this.props.propertyData.property.deal.imageLarge
          }
          cardComponent={
            <PropertyHeroCard {...{ ...this.props, buttonListOverride: this.state.heroCardButtons, backLabel: "Deal Summary", onBackButtonClick: this.onBackButtonClick }} />
          }
          bodyComponent={
            <StyledBodyWrapper>
              {this.renderTitle()}
              {this.renderBody()}
            </StyledBodyWrapper>
          }
        />

        <SimpleInfoModal
          title={this.state.confirmationModal.title}
          isOpen={this.isModalOpen(SIMPLE_INFO_MODAL)}
          onClose={() => this.state.confirmationModal.onClose()}
          onAccept={() => this.state.confirmationModal.onAccept()}
          content={this.state.confirmationModal.content}
        />

        <UploadRentRollModal
          title={this.state.confirmationModal.title}
          isOpen={this.isModalOpen(UPLOAD_RENT_ROLL_MODAL)}
          onClose={() => this.state.confirmationModal.onClose()}
          userId={this.props.authentication.user.id}
          propertyData={this.props.propertyData}
          companyId={this.props.company && this.props.company.id}
        />
      </>
    );
  }
}

const mapStateToProps = ({ newPropertyDetail, authentication, accountingIntegration }) => ({
  ...newPropertyDetail,
  guestPermission: mapGuestPermissions(authentication, newPropertyDetail.guestPermission),
  company: mapCompanySelector(authentication),
  accountingIntegrations: accountingIntegration.items,
  authentication
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    propertyDetailGetProperty,
    propertyDetailGetDealMetrics,
    propertyDetailGetNewPropertyOwner,
    propertyDetailGetNewProperty,
    getPropertiesAndProjectionsOfDealByPropertyId,
    deleteProperty,
    getAccountingIntegrationsForModel
  })
)(PropertyDetail);
